/*Состояния*/
const state = () => ({
  /*Объект с отзывами*/
  objFeedback: [],

  /*Сообщение об ошибке*/
  message: [],
});
export { state };
